export default {
  equipment: 'Equipment',
  service: 'Service',
  createdAt: 'Created At',
  lastModifiedAt: 'Last Modified At',
  actions: 'Actions',
  place: 'Place',
  fromCreatedAt: 'Created From:',
  toCreatedAt: 'Created To:',
  fromModifiedAt: 'Modified From:',
  toModifiedAt: 'Modified To:',
  pageTitle: 'Service Drafts',
  finishService: 'Finish Service',
  deleteDraftTitle: 'Delete Service Draft',
  deleteDraftMessage: 'Are you sure you want to delete the service draft?',
};
